import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { Col, Row } from "reactstrap";
import { Box, Button } from "@mui/material";
import PropTypes from "prop-types";

import DocumentPreviewModal from "Components/Common/DocumentPreviewModal";
import CommentInputForReason from "Components/Common/CommentInputForReason";

import { getImageUrl } from "utils";
import getFileExtension from "utils/getFileExtension";
import removeExtension from "utils/removeExtension";

import { usePostApprovePendingDocumentsMutation } from "apis/DocumentType";
import ConfirmationDialog from "Components/Common/ConfirmationDialog";

const PreviewPendingDocuments = ({
  applicationId,
  documents,
  handleClose,
  t,
}) => {
  const [documentToPreview, setDocumentToPreview] = useState();
  const [isRejectionCommentModalVisible, setIsRejectionCommentModalVisible] =
    useState(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const [
    approvePendingDocument,
    { isLoading: isPendingDocumentApprovalLoading },
  ] = usePostApprovePendingDocumentsMutation();

  const submitHandlerForRejection = async (comment) => {
    try {
      await approvePendingDocument({
        applicationId,
        isApproved: false,
        comment,
      });
      handleClose();
      setIsRejectionCommentModalVisible(false);
    } catch (error) {}
  };

  const approvePendingDocuments = async () => {
    try {
      await approvePendingDocument({
        applicationId,
        isApproved: true,
      });
      handleClose();
    } catch (error) {}
  };
  return (
    <>
      {isConfirmationModalOpen && (
        <ConfirmationDialog
          isOpen
          title="Warning"
          message="Are you sure you want to approve documents?"
          onCancel={() => setIsConfirmationModalOpen(false)}
          onConfirm={approvePendingDocuments}
          isLoading={isPendingDocumentApprovalLoading}
          variant="warning"
        />
      )}
      <CommentInputForReason
        handleClose={() => {
          setIsRejectionCommentModalVisible(false);
        }}
        handleSubmit={submitHandlerForRejection}
        isOpen={isRejectionCommentModalVisible}
        isLoading={isPendingDocumentApprovalLoading}
        title="Add Reason for Rejection"
        errorMessage="Please enter reason for rejection"
      />
      {!!documentToPreview && (
        <DocumentPreviewModal
          isOpen
          handleClose={() => setDocumentToPreview(null)}
          {...documentToPreview}
        />
      )}
      <Row className="d-flex w-100 mt-2 ms-2 mt-3">
        {documents.map(
          (
            {
              name,
              documentTypeDescription,
              documentURL,
              documentTypeName,
              id,
            },
            index
          ) => {
            return (
              <Col lg={12} className="mb-1" key={index}>
                <Row className="mb-2">
                  <Col lg={10}>{`${documentTypeDescription}`}</Col>
                  <Col lg={2} className="fw-semibold">
                    <Button
                      onClick={() =>
                        setDocumentToPreview({
                          documentTypeName,
                          url: getImageUrl(documentURL),
                          documentType: getFileExtension(name),
                          documentName: removeExtension(name),
                        })
                      }
                      disabled={!id}
                      variant="outlined"
                      size="small"
                    >
                      {t("View")}
                    </Button>
                  </Col>
                </Row>
              </Col>
            );
          }
        )}
      </Row>
      <Box className="d-flex justify-content-end gap-2">
        <Button
          onClick={() => setIsRejectionCommentModalVisible(true)}
          variant="contained"
          color="error"
        >
          {t("Reject")}
        </Button>
        <Button
          onClick={() => setIsConfirmationModalOpen(true)}
          variant="contained"
          color="success"
        >
          {t("Approve")}
        </Button>
      </Box>
    </>
  );
};

export default withTranslation()(PreviewPendingDocuments);

PreviewPendingDocuments.propTypes = {
  documents: PropTypes.array,
  t: PropTypes.func,
  applicationId: PropTypes.number,
  handleClose: PropTypes.func,
};
